import type { ReactNode } from 'react';
import { Loader } from '~/components/ui';
import styles from './RoutePending.module.css';

/**
 * Route-level pending fallback (the router's `defaultPendingComponent`). Shown
 * only when a route's awaited `beforeLoad`/`loader` work exceeds
 * `defaultPendingMs` (600ms) — rare, since loaders await only auth and prefetch
 * data non-blockingly. A plain centered spinner; per-surface skeletons handle
 * the common in-component loading state.
 */
export function RoutePending(): ReactNode {
  return (
    <div className={styles.pending ?? ''} data-testid="route-pending">
      <Loader size="md" />
    </div>
  );
}
